import { createElement, forwardRef } from 'react';
import {
  ArrowLeft,
  ArrowRight,
  AudioWaveform,
  BarChart3,
  BriefcaseBusiness,
  Calendar,
  CalendarDays,
  Check,
  CheckCircle2,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  Clock,
  Compass,
  Clock3,
  Code2,
  Copy,
  CreditCard,
  Dices,
  Download,
  Ellipsis,
  EllipsisVertical,
  ExternalLink,
  Eye,
  Facebook,
  FileText,
  FlaskConical,
  Gift,
  GitBranch,
  Globe,
  History,
  Home,
  Info,
  Infinity,
  Languages,
  Linkedin,
  Loader2,
  Lock,
  LogIn,
  LogOut,
  Mail,
  MailPlus,
  MessageCircle,
  Mic,
  Mic2,
  Moon,
  Play,
  Plus,
  RotateCcw,
  ScrollText,
  Search,
  Send,
  Settings,
  Settings2,
  Shield,
  ShieldAlert,
  ShieldCheck,
  Sparkles,
  Square,
  Star,
  Sun,
  Tag,
  Terminal,
  TriangleAlert,
  Trophy,
  Twitter,
  User,
  User2,
  UserRoundCog,
  Users,
  Volume2,
  X,
  XCircle,
  Zap,
} from 'lucide-react';
import { AlligatorMascot } from './icons-custom/AlligatorMascot.js';
import { GatorScore } from './icons-custom/GatorScore.js';
import { ThreeStages } from './icons-custom/ThreeStages.js';
import type { IconComponent, IconName, IconBaseProps } from './types.js';

const Google = forwardRef<SVGSVGElement, IconBaseProps>(({ className, size = 24, ...props }, ref) =>
  createElement(
    'svg',
    {
      ref,
      viewBox: '0 0 24 24',
      width: size,
      height: size,
      className,
      'aria-hidden': 'true',
      xmlns: 'http://www.w3.org/2000/svg',
      ...props,
    },
    createElement('path', {
      d: 'M22.501 12.233c0-.78-.064-1.35-.203-1.94H12.214v3.978h5.919c-.119.989-.761 2.478-2.189 3.478l-.02.133 3.252 2.47.225.022c2.061-1.868 3.1-4.616 3.1-8.141Z',
      fill: '#4285F4',
    }),
    createElement('path', {
      d: 'M12.214 22.5c2.899 0 5.334-.934 7.112-2.533l-3.457-2.625c-.925.633-2.168 1.076-3.655 1.076-2.838 0-5.252-1.868-6.109-4.449l-.128.01-3.381 2.565-.044.12C4.319 20.073 7.998 22.5 12.214 22.5Z',
      fill: '#34A853',
    }),
    createElement('path', {
      d: 'M6.105 13.969a6.222 6.222 0 0 1-.358-2.08c0-.724.129-1.425.343-2.08l-.006-.139-3.423-2.607-.112.052A10.115 10.115 0 0 0 1.5 11.889c0 1.564.379 3.043 1.049 4.374l3.556-2.294Z',
      fill: '#FBBC05',
    }),
    createElement('path', {
      d: 'M12.214 5.358c1.877 0 3.142.799 3.86 1.467l2.818-2.69C17.542 2.9 15.113 1.5 12.214 1.5c-4.216 0-7.895 2.427-9.662 5.965l3.541 2.694c.864-2.58 3.278-4.801 6.121-4.801Z',
      fill: '#EA4335',
    }),
  ),
);

Google.displayName = 'google';

export const iconMap: Record<IconName, IconComponent> = {
  'alligator-mascot': AlligatorMascot,
  'arrow-left': ArrowLeft,
  'arrow-right': ArrowRight,
  'audio-waveform': AudioWaveform,
  'bar-chart-3': BarChart3,
  'briefcase-business': BriefcaseBusiness,
  calendar: Calendar,
  'calendar-days': CalendarDays,
  check: Check,
  'check-circle-2': CheckCircle2,
  'chevron-down': ChevronDown,
  'chevron-left': ChevronLeft,
  'chevron-right': ChevronRight,
  compass: Compass,
  clock: Clock,
  'clock-3': Clock3,
  copy: Copy,
  'code-2': Code2,
  'credit-card': CreditCard,
  dices: Dices,
  download: Download,
  ellipsis: Ellipsis,
  'ellipsis-vertical': EllipsisVertical,
  'external-link': ExternalLink,
  eye: Eye,
  facebook: Facebook,
  'file-text': FileText,
  'flask-conical': FlaskConical,
  'gator-score': GatorScore,
  gift: Gift,
  'git-branch': GitBranch,
  globe: Globe,
  google: Google,
  history: History,
  home: Home,
  info: Info,
  infinity: Infinity,
  languages: Languages,
  linkedin: Linkedin,
  'loader-2': Loader2,
  lock: Lock,
  'log-in': LogIn,
  'log-out': LogOut,
  mail: Mail,
  'mail-plus': MailPlus,
  'message-circle': MessageCircle,
  mic: Mic,
  'mic-2': Mic2,
  moon: Moon,
  play: Play,
  plus: Plus,
  'rotate-ccw': RotateCcw,
  'scroll-text': ScrollText,
  search: Search,
  send: Send,
  settings: Settings,
  'settings-2': Settings2,
  shield: Shield,
  'shield-alert': ShieldAlert,
  'shield-check': ShieldCheck,
  sparkles: Sparkles,
  square: Square,
  star: Star,
  sun: Sun,
  tag: Tag,
  terminal: Terminal,
  'three-stages': ThreeStages,
  'triangle-alert': TriangleAlert,
  trophy: Trophy,
  twitter: Twitter,
  user: User,
  'user-2': User2,
  'user-round-cog': UserRoundCog,
  users: Users,
  'volume-2': Volume2,
  x: X,
  'x-circle': XCircle,
  zap: Zap,
};
